import gql from 'graphql-tag';
import { customQueueFragment } from './fragments';

export const insertCustomQueue = gql`
  mutation insertCustomQueue($customQueue: CustomQueueInput!) {
    insertCustomQueue(customQueue: $customQueue) {
      ...customQueueParts
    }
  }
  ${customQueueFragment}
`;

export const updateCustomQueue = gql`
  mutation updateCustomQueue(
    $customQueueId: Int!
    $customQueue: CustomQueueInput!
  ) {
    updateCustomQueue(
      customQueueId: $customQueueId
      customQueue: $customQueue
    ) {
      ...customQueueParts
    }
  }
  ${customQueueFragment}
`;

export const changeCustomQueueEnabled = gql`
  mutation changeCustomQueueEnabled($customQueueId: Int!, $enabled: Boolean!) {
    changeCustomQueueEnabled(customQueueId: $customQueueId, enabled: $enabled) {
      ...customQueueParts
    }
  }
  ${customQueueFragment}
`;

export const deleteCustomQueue = gql`
  mutation deleteCustomQueue($customQueueId: Int!) {
    deleteCustomQueue(customQueueId: $customQueueId)
  }
`;

export const reorderCustomQueues = gql`
  mutation reorderCustomQueues(
    $partnerPersonContextId: Int!
    $customQueueIds: [Int!]!
  ) {
    reorderCustomQueues(
      partnerPersonContextId: $partnerPersonContextId
      customQueueIds: $customQueueIds
    ) {
      ...customQueueParts
    }
  }
  ${customQueueFragment}
`;
